import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  selected: {
    color: theme.palette.black.main,
    backgroundColor: theme.palette.primary.background,
  },
}));
